import React, { useState } from "react"
import { manageAccountResetPassword } from "../../../api/manage_account_reset_password"
import { useNavigate } from "react-router-dom"
import { ManageAccountData } from "./"
import { useLoading } from "../../LoadingContext"

import Card from "@mui/material/Card"
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import MDInput from "components/MDInput"
import MDButton from "components/MDButton"

interface ManageEstateResetPasswordProps {
  onClose: (num: number) => void // モーダルを閉じるためのコールバック
  accountData: ManageAccountData | null // 編集するサービス提供元データをプロパティとして受け取る
}

const ManageAccountEstateResetPassword: React.FC<ManageEstateResetPasswordProps> = ({ onClose, accountData }) => {
  const { startLoading, stopLoading } = useLoading()
  const navigate = useNavigate()
  const [isFinish, setIsFinish] = useState<boolean>(false)
  const [formData] = useState({
    id: accountData?.id,
    estate_id: accountData?.estate_id,
    name: accountData?.name,
    mail: accountData?.mail,
    auth_facility: accountData?.auth_facility === 1,
    auth_list: accountData?.auth_list === 1,
    auth_setting: accountData?.auth_setting === 1
  })

  const [errors, setErrors] = useState({
    name: "",
    mail: "",
    server: ""
  })

  const validate = () => {
    const validationErrors = { ...errors }
    validationErrors.server = ""
    setErrors(validationErrors)
    return true
  }

  const convertEnabledValues = (data: any) => {
    return data
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (validate()) {
      // バリデーション成功時の処理
      try {
        startLoading()
        const convertedData = convertEnabledValues(formData)
        await manageAccountResetPassword(convertedData.id)
        setIsFinish(true)
      } catch (error: any) {
        if (error.response && error.response.status === 401) {
          navigate("/login") // セッション切れ時にトップページへリダイレクト
        } else if (error.response) {
          const errorDetail = error.response.data.detail
          const validationErrors = {
            name: "",
            mail: "",
            server: ""
          }
          validationErrors.server = errorDetail.message
          setErrors(validationErrors)
        } else {
          const validationErrors = {
            name: "",
            mail: "",
            server: ""
          }
          validationErrors.server = "サーバーへの接続に失敗しました"
          setErrors(validationErrors)
        }
      } finally {
        stopLoading()
      }
    }
  }

  return (
    <div className="modal-bg-cover">
      <Card
        sx={{
          width: "90%",
          maxWidth: "500px",
          maxHeight: "calc(100vh - 100px)",
          marginTop: "50px",
          marginBottom: "50px",
          paddingTop: "20px",
          paddingBottom: "20px",
          paddingLeft: "20px"
        }}
      >
        <button className="close-button" onClick={() => onClose(isFinish ? 1 : 0)}>
          ×
        </button>
        {!isFinish ? (
          <>
            <MDTypography variant="h4" fontWeight="medium">
              パスワード初期化
            </MDTypography>
            <MDBox style={{ height: "20px" }}></MDBox>
            <MDBox
              style={{
                maxHeight: "calc(100vh - 200px)",
                overflowY: "auto",
                paddingTop: "10px",
                paddingLeft: "5px",
                paddingRight: "25px"
              }}
            >
              <MDBox mb={2}>以下のアカウントのパスワードを初期化します</MDBox>
              <MDBox display="flex" alignItems="center" gap={1} mb={2}>
                <MDInput
                  label="ID"
                  type="text"
                  name="id"
                  value={formData.id}
                  sx={{ width: "100%" }}
                  inputProps={{ readOnly: true }}
                />
              </MDBox>
              <MDBox display="flex" alignItems="center" gap={1} mb={2}>
                <MDInput
                  label="名前"
                  type="text"
                  name="name"
                  value={formData.name}
                  sx={{ width: "100%" }}
                  inputProps={{ readOnly: true }}
                />
              </MDBox>
              <MDBox display="flex" alignItems="center" gap={1} mb={2}>
                <MDInput
                  label="メールアドレス"
                  type="text"
                  name="mail"
                  value={formData.mail}
                  sx={{ width: "100%" }}
                  inputProps={{ readOnly: true }}
                />
              </MDBox>
              <MDBox mt={4} mb={2}>
                <MDButton
                  variant="contained"
                  color="info"
                  fullWidth
                  sx={{
                    borderRadius: "4px",
                    textTransform: "none",
                    fontSize: "1rem",
                    padding: "0.75rem 0",
                    backgroundColor: "#1976d2",
                    "&:hover": {
                      backgroundColor: "#1565c0"
                    }
                  }}
                  onClick={(e) => {
                    handleSubmit(e)
                  }}
                >
                  パスワード初期化
                </MDButton>
              </MDBox>
            </MDBox>
            {errors.server && (
              <MDBox
                color="#FF0000" // テキスト色
                pl={2} // 左パディング
                mb={2} // 下マージン
                fontSize="0.7em" // フォントサイズ
              >
                {errors.server}
              </MDBox>
            )}
          </>
        ) : (
          <>
            <MDTypography variant="h4" fontWeight="medium">
              パスワード初期化完了
            </MDTypography>
            <MDBox style={{ height: "20px" }}></MDBox>
            <MDBox
              style={{
                maxHeight: "calc(100vh - 200px)",
                overflowY: "auto",
                paddingTop: "10px",
                paddingLeft: "5px",
                paddingRight: "25px"
              }}
            >
              <MDBox mb={2}>パスワードを初期化しました</MDBox>
            </MDBox>
          </>
        )}
      </Card>
    </div>
  )
}

export default ManageAccountEstateResetPassword
